<template>
    <form class="is-clearfix">
        <h1 class="title is-3">{{ $route.params.slug }}</h1>
        <div class="columns">
            <div class="column">
                <o-field label="Name">
                    <o-input v-model="service.name"></o-input>
                </o-field>

                <o-field label="Price">
                    <o-input v-model="service.price"></o-input>
                </o-field>

                <o-field label="Notes">
                    <o-input v-model="service.notes" maxlength="200" type="textarea"></o-input>
                </o-field>

            </div>
        </div>

        <div class="field is-grouped is-pulled-right">
            <p class="control">
                <router-link :to="{ name: 'services.index' }" class="button" >Cancel</router-link>
            </p>
            <p class="control">
                <button @click.prevent="confirmCustomDelete" class="button is-danger">Delete</button>
            </p>
            <p class="control">
                <button @click.prevent="success" class="button is-success">Save</button>
            </p>
        </div>
    </form>
</template>

<script>
    import Datepicker from '../../components/Datepicker';

    export default {
        components: {
            Datepicker
        },
        data() {
            return {
                service: {
                    name: 'Lorem ipsum dolor',
                    price: '234',
                    notes: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumque dolorem quas laudantium vel architecto illum ex, corporis tenetur id possimus aut quisquam placeat, minima laborum vitae animi fuga quidem temporibus!',
                }
            }
        },

        methods: {
            confirmCustomDelete() {
                this.$swal.fire({
                    title: 'Deleting Service',
                    text: 'Are you sure you want to <strong>delete</strong> this service? This action cannot be undone.',
                    confirmText: 'Delete Service',
                    icon: 'error',
                    hasIcon: true,
                    onConfirm: () => {
                        this.$swal.fire('Service deleted!')
                    }
                })
            },
            success() {
                this.$swal.fire({
                    text: 'Changes has been saved',
                    icon: 'success'
                })
            },
        }
    }
</script>
